import React, { useEffect } from 'react';
import { connect } from "react-redux";
import './DlUnitLi.scss';
import { getSerLi } from "../../actions";
import AddNew from './AddNew';
import AdmPhotoSerEl from './AdmPhotoSerEl';

const mapStateToProps = (state) => ({
  itemN: state.phSerLi.phSN
});

const mapDispatchToProps = (dispatch) => ({
  getItemLi: (payload) => dispatch(getSerLi(payload))
});

const AdmPhotoSerLi = ({ itemN, getItemLi }) => {

  useEffect(function() {
    getItemLi({});
  }, []);

  // getUnitLi({dlUnitCond: cond, dlUnitMaxPerPage});

  const itemLi = itemN.map( (item, ind) => (
    <AdmPhotoSerEl key={ind} item={item} />
  ) );


  return (
    <div>
      <AddNew adr={'/admin-dashboard/photo-ser-edit'} addStyle={{ marginTop: '0em' }} />
      { itemLi }
    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(AdmPhotoSerLi);
